import ApiBase from './api_base'
import lodash from 'lodash'

export default class ProjectApi {
  static index(params) {
    return ApiBase.get('/projects',
      lodash.pick(params, ['category_id', 'organization_id', 'page']))
  }

  static states(params) {
    return ApiBase.get('/projects/states', lodash.pick(params, ['ids']))
  }

  static show(id) {
    return ApiBase.get(`/projects/${id}`)
  }

  static state(id) {
    return ApiBase.get(`/projects/${id}/state`)
  }

  static destroy(id) {
    if (!id) {
      throw new Error('ArgumentError')
    }
    return ApiBase.delete(`/projects/${id}`)
  }

  static create(params) {
    return ApiBase.post(params.organization_id ? `/organizations/${params.organization_id}/projects` : '/projects', {
      file_id: params.file_id,
      qn_file_id: params.qn_file_id,
      project: lodash.pick(params, ['source_filename', 'category_id'])
    })
  }

  static update(id, params) {
    console.log('tbc params', !params.tbc ? null : lodash.pick(params.tbc, ['sync_course', 'sync_knowledge', 'public']))
    return ApiBase.put(`/projects/${id}`, {
      file_id: params.file_id,
      qn_file_id: params.qn_file_id,
      tbc: !params.tbc ? null : lodash.pick(params.tbc, ['sync_course', 'sync_knowledge', 'public']),
      project: lodash.pick(params, [
        'name', 'source_filename', 'thumbnail', // 项目名,源文件名,封面
        'bgm', 'bgm_name', 'bgm_volume', // 背景音乐相关
        'category_id', // 分类相关
        'cover', 'title', 'description', // wechat share related field
        'logo', // logo
        'arrow_mode', 'transition_ctrl', 'stretch_mode', 'auto_play', 'forbid_share', // 翻页小箭头, 翻页控制, 页面适配, 自动播放,允许微信转发
        'auth_type', 'auth_config', 'pay_to_read_price', // 访问权限相关
        'test'
      ])
    })
  }

  static recordQrcode(id) {
    return ApiBase.get(`/projects/${id}/action_record/editor_qrcode`)
  }

  static stats(id) {
    return ApiBase.get(`/projects/${id}/stats`)
  }

  static formRecords(params) {
    return ApiBase.get(`/projects/${params.id}/form_records`, lodash.pick(params, ['page']))
  }

  static deleteFormRecords(params) {
    return ApiBase.delete(`/projects/${params.id}/form_records/id`, lodash.pick(params, ['batch_ids']))
  }

  // 导出相关 api
  static createExport(params) {
    return ApiBase.post(`/projects/${params.id}/export`, lodash.pick(params, ['export_format']))
  }

  static checkExport(id) {
    return ApiBase.get(`/projects/${id}/export`)
  }
}



// WEBPACK FOOTER //
// ./src/api/project.js